function addClass(el, ...classNames) {
  if (!(el instanceof Element) || classNames.length === 0) return;
  classNames.forEach((className) => {
    if (typeof className !== "string" || className.trim() === "") return;
    if (el.classList) {
      el.classList.add(className);
    } else if (!el.className.includes(className)) {
      el.className += (el.className ? " " : "") + className;
    }
  });
}
function removeClass(el, ...classNames) {
  if (!(el instanceof Element) || classNames.length === 0) return;
  classNames.forEach((className) => {
    if (typeof className !== "string" || className.trim() === "") return;
    if (el.classList) {
      el.classList.remove(className);
    } else {
      const pattern = new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi");
      el.className = el.className.replace(pattern, " ").trim();
    }
  });
}
function ajax(options = {}, args = null) {
  const defaultConfig = {
    cache: false,
    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
    data: null,
    dataObject: null,
    headers: {},
    method: "GET",
    url: "",
    withCredentials: false,
    success: (resp) => console.warn(resp),
    error: (err) => console.warn(err)
  };
  const config = { ...defaultConfig, ...options };
  if (!config.url) {
    throw new Error("URL is required");
  }
  let requestUrl = config.url;
  if (!config.cache) {
    const ts = `ts=${Date.now()}`;
    requestUrl += (requestUrl.includes("?") ? "&" : "?") + ts;
  }
  const fetchOptions = {
    method: config.method,
    headers: {
      ...config.headers,
      "Content-Type": config.contentType
    },
    credentials: config.withCredentials ? "include" : "same-origin"
  };
  if (config.data) {
    fetchOptions.body = typeof config.data === "string" ? config.data : objectToQueryString(config.data);
  } else if (config.dataObject) {
    fetchOptions.body = config.dataObject;
  }
  return fetch(requestUrl, fetchOptions).then(async (response) => {
    const contentType = response.headers.get("content-type");
    let parsed;
    if (contentType && contentType.includes("application/json")) {
      parsed = await response.json();
    } else {
      parsed = await response.text();
    }
    if (response.ok) {
      const status = parsed == null ? void 0 : parsed.status;
      if (typeof status === "undefined" || typeof status === "number" && status >= 200 && status < 400 || status === "success") {
        config.success(parsed, args);
        return parsed;
      } else {
        config.error(parsed, args);
        throw parsed;
      }
    } else {
      config.error(parsed, args);
      throw parsed;
    }
  }).catch((err) => {
    config.error(err, args);
    throw err;
  });
}
function objectToQueryString(obj) {
  return Object.entries(obj).map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join("&");
}
function initProductCardSwatchListeners(scope = document) {
  const $swatches = scope.querySelectorAll(".js-swap-product");
  $swatches.forEach(($swatch) => {
    $swatch.addEventListener("click", (e) => {
      e.preventDefault();
      const img = $swatch.querySelector("img");
      if (img && img.classList.contains("activeSwatch")) {
        return;
      }
      const swatchLink = e.target.closest(".js-swap-product");
      const jsonResource = swatchLink.dataset.handlejs;
      const $productCard = $swatch.closest("article");
      const $wrapper = $productCard.closest(".product-card-wrapper");
      const cached = window.productSwatchCache[jsonResource];
      if (cached) {
        updateProductCard(cached);
      } else {
        window.productSwatchInFlight[jsonResource] = true;
        ajax({ method: "GET", url: jsonResource }).then((response) => {
          window.productSwatchCache[jsonResource] = response;
          updateProductCard(response);
        }).catch((error) => {
          console.warn("Swatch fetch failed:", error);
          swatchLink.parentElement.remove();
          const $overlay = $wrapper.querySelector(".js-loading-overlay");
          if ($overlay) {
            removeClass($overlay, "opacity-100");
            addClass($overlay, "opacity-0");
          }
          $wrapper.style.height = "";
        }).finally(() => {
          delete window.productSwatchInFlight[jsonResource];
        });
      }
      function waitForTransitionEnd($el) {
        return new Promise((resolve) => {
          const handler = (e2) => {
            if (e2.propertyName === "opacity") {
              $el.removeEventListener("transitionend", handler);
              resolve();
            }
          };
          $el.addEventListener("transitionend", handler);
        });
      }
      function lockProductImgHeight(cardEl, fromEl) {
        var _a;
        const newImgWrap = cardEl.querySelector(".product-img");
        const oldImgWrap = (_a = fromEl == null ? void 0 : fromEl.querySelector) == null ? void 0 : _a.call(fromEl, ".product-img");
        if (!newImgWrap || !oldImgWrap) return;
        const height = oldImgWrap.offsetHeight || oldImgWrap.getBoundingClientRect().height || 0;
        if (height > 0) newImgWrap.style.height = `${height}px`;
      }
      function unlockProductImgHeight(cardEl) {
        const wrap = cardEl.querySelector(".product-img");
        if (wrap) wrap.style.height = "";
      }
      async function updateProductCard(response) {
        const $overlay = $wrapper.querySelector(".js-loading-overlay");
        if ($overlay) {
          removeClass($overlay, "opacity-0");
          addClass($overlay, "opacity-100");
          await waitForTransitionEnd($overlay);
        }
        const parser = new DOMParser();
        const doc = parser.parseFromString(response, "text/html");
        const newCard = doc.querySelector(".product-card");
        if (!newCard) {
          console.warn("No `.product-card` found in response");
          if ($overlay) {
            removeClass($overlay, "opacity-100");
            addClass($overlay, "opacity-0");
          }
          $wrapper.style.height = "";
          return;
        }
        lockProductImgHeight(newCard, $productCard);
        const wrapperHeight = $wrapper.offsetHeight;
        $wrapper.style.height = `${wrapperHeight}px`;
        $wrapper.replaceChild(newCard, $productCard);
        if (window.lazySizes) window.lazySizes.init();
        const $swatchList = newCard.querySelector("ul");
        if ($swatchList) addClass($swatchList, "opacity-0");
        const lazyImgs = newCard.querySelectorAll("img.lazyload");
        if (lazyImgs.length === 0) {
          requestAnimationFrame(() => {
            if ($overlay) {
              removeClass($overlay, "opacity-100");
              addClass($overlay, "opacity-0");
            }
          });
        } else {
          let loadedCount = 0;
          const handleImgLoaded = () => {
            loadedCount++;
            if (loadedCount === lazyImgs.length) {
              if ($overlay) {
                removeClass($overlay, "opacity-100");
                addClass($overlay, "opacity-0");
              }
              lazyImgs.forEach((img2) => {
                img2.removeEventListener("lazyloaded", handleImgLoaded);
              });
            }
          };
          lazyImgs.forEach((img2) => {
            img2.addEventListener("lazyloaded", handleImgLoaded);
          });
        }
        initProductCardSwatchListeners(newCard);
        const newSwatches = newCard.querySelectorAll(".js-swap-product");
        const swatchFetches = [];
        newSwatches.forEach(async (swatch) => {
          var _a;
          const jsonResource2 = swatch.dataset.handlejs;
          const cachedHTML = window.productSwatchCache[jsonResource2];
          if (cachedHTML === "404") {
            (_a = swatch.parentNode) == null ? void 0 : _a.remove();
            return;
          }
          if (cachedHTML) {
            markSoldOutFromHTML(cachedHTML, swatch);
            return;
          }
          if (!jsonResource2 || window.productSwatchInFlight[jsonResource2]) return;
          window.productSwatchInFlight[jsonResource2] = true;
          const fetchPromise = fetch(jsonResource2).then((res) => {
            var _a2;
            if (!res.ok) {
              if (res.status === 404) {
                console.warn(`404: removing swatch: ${jsonResource2}`);
                (_a2 = swatch.parentNode) == null ? void 0 : _a2.remove();
              }
              return null;
            }
            return res.text();
          }).then((html) => {
            if (!html) return;
            window.productSwatchCache[jsonResource2] = html;
            markSoldOutFromHTML(html, swatch);
            preloadImagesFromHTML(html);
          }).catch((err) => {
            console.warn("Swatch preload failed:", err);
          }).finally(() => {
            delete window.productSwatchInFlight[jsonResource2];
          });
          swatchFetches.push(fetchPromise);
        });
        const swatchReady = Promise.race([
          Promise.all(swatchFetches),
          new Promise((resolve) => setTimeout(resolve, 1e3))
        ]);
        Promise.all([swatchReady]).then(() => {
          if ($swatchList) {
            removeClass($swatchList, "opacity-0");
            addClass($swatchList, "opacity-100");
          }
          $wrapper.style.height = "";
          if ($overlay) {
            removeClass($overlay, "opacity-100");
            addClass($overlay, "opacity-0");
          }
        });
      }
      setTimeout(() => {
        const $overlay = $wrapper.querySelector(".js-loading-overlay");
        const swatchlist = $wrapper.querySelector(".product-swatch-list");
        if (swatchlist) removeClass(swatchlist, "opacity-0");
        applyMoreColorsIndicator($wrapper);
        unlockProductImgHeight($wrapper);
        if ($overlay && $overlay.classList.contains("opacity-100")) {
          console.warn("Overlay timeout fallback triggered");
          removeClass($overlay, "opacity-100");
          addClass($overlay, "opacity-0");
          $wrapper.style.height = "";
        }
      }, 1e3);
    });
  });
}
function markSoldOutFromHTML(html, swatch) {
  const soldOutMarker = '<div class="redesign-body-8 text-charcoal-100 mt-[12px]">Sold Out</div>';
  if (!html.includes(soldOutMarker)) return;
  const handle = swatch.dataset.handlejs;
  if (!handle) return;
  const matchingSwatches = document.querySelectorAll(`.js-swap-product[data-handlejs="${handle}"]`);
  matchingSwatches.forEach((el) => {
    const img = el.querySelector("img");
    addClass(el, "sold-out");
    if (!img || !img.classList.contains("activeSwatch")) {
      addClass(el, "hover:bg-ivory");
    }
  });
}
function applyMoreColorsIndicator(cardEl) {
  setTimeout(() => {
    const list = cardEl.querySelector(".product-swatch-list");
    if (!list) return;
    const lis = Array.from(list.querySelectorAll(":scope > li")).filter((li) => !li.classList.contains("more-indicator"));
    const swatchLis = lis.filter((li) => li.querySelector(".js-swap-product"));
    const total = swatchLis.length;
    const limit = 4;
    if (total <= limit) return;
    if (list.querySelector("li.more-indicator a")) {
      list.querySelector("li.more-indicator").classList.remove("hidden");
    }
  }, 500);
}
function preloadImagesFromHTML(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const images = doc.querySelectorAll("img");
  images.forEach((img) => {
    const srcset = img.getAttribute("data-srcset") || img.getAttribute("srcset");
    if (srcset) {
      const srcsetParts = srcset.split(",").map((s) => s.trim());
      const largest = srcsetParts[srcsetParts.length - 1];
      const [largestUrl] = largest.split(" ");
      const preloadImg = new Image();
      preloadImg.decoding = "async";
      preloadImg.loading = "eager";
      preloadImg.src = largestUrl.startsWith("//") ? "https:" + largestUrl : largestUrl;
      return;
    }
    let rawSrc = img.getAttribute("data-src") || img.getAttribute("src");
    if (rawSrc) {
      rawSrc = rawSrc.replace("{width}", "540");
      const fullUrl = rawSrc.startsWith("//") ? "https:" + rawSrc : rawSrc;
      const preloadImg = new Image();
      preloadImg.decoding = "async";
      preloadImg.loading = "eager";
      preloadImg.src = fullUrl;
    }
  });
}
const utilityProductSwatch = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  applyMoreColorsIndicator,
  initProductCardSwatchListeners,
  markSoldOutFromHTML,
  preloadImagesFromHTML
}, Symbol.toStringTag, { value: "Module" }));
async function renderProductCardsFromHandles(handles, container, {
  view = "get-product-card",
  cardClasses = ["basis-[calc(50%-4px)]", "lg:basis-[calc(25%_-_8px)]"],
  action = "replace"
  // 'replace' | 'append'
} = {}) {
  if (!Array.isArray(handles) || !container) return;
  window.productSwatchCache = window.productSwatchCache || {};
  window.productSwatchInFlight = window.productSwatchInFlight || {};
  const fragment = document.createDocumentFragment();
  const htmlResults = new Array(handles.length);
  const cardPromises = handles.map(async (handle, index) => {
    const jsonResource = `/products/${handle}?view=${view}`;
    if (window.productSwatchCache[jsonResource]) {
      htmlResults[index] = window.productSwatchCache[jsonResource];
      return;
    }
    if (window.productSwatchInFlight[jsonResource]) return;
    window.productSwatchInFlight[jsonResource] = true;
    try {
      const res = await fetch(jsonResource);
      if (!res.ok) throw new Error(`Fetch failed for ${jsonResource}`);
      const html = await res.text();
      window.productSwatchCache[jsonResource] = html;
      htmlResults[index] = html;
    } catch (err) {
      console.warn(`Error rendering product card for ${handle}:`, err);
      htmlResults[index] = null;
    } finally {
      delete window.productSwatchInFlight[jsonResource];
    }
  });
  await Promise.all(cardPromises);
  for (let i = 0; i < htmlResults.length; i++) {
    const html = htmlResults[i];
    if (!html) continue;
    const $card = document.createElement("div");
    $card.innerHTML = html;
    $card.classList.add(...cardClasses);
    fragment.appendChild($card);
    initProductCardSwatchListeners($card);
    handleSwatches($card);
  }
  if (action === "append") {
    container.appendChild(fragment);
  } else {
    container.replaceChildren(fragment);
  }
  function handleSwatches($card, timeoutMs = 1e3) {
    const swatches = Array.from($card.querySelectorAll(".js-swap-product"));
    const tasks = swatches.map(async (swatch) => {
      var _a;
      const swatchResource = swatch.dataset.handlejs;
      if (window.productSwatchCache[swatchResource] === "404") {
        document.querySelectorAll(`.js-swap-product[data-handlejs="${swatchResource}"]`).forEach((el) => {
          var _a2;
          return (_a2 = el.parentElement) == null ? void 0 : _a2.remove();
        });
        return;
      } else if (!swatchResource || window.productSwatchCache[swatchResource] || window.productSwatchInFlight[swatchResource]) return;
      window.productSwatchInFlight[swatchResource] = true;
      try {
        const swatchRes = await fetch(swatchResource);
        if (!swatchRes.ok) {
          window.productSwatchCache[swatchResource] = "404";
          document.querySelectorAll(`.js-swap-product[data-handlejs="${swatchResource}"]`).forEach((el) => {
            var _a2;
            return (_a2 = el.parentElement) == null ? void 0 : _a2.remove();
          });
          return;
        }
        const swatchHtml = await swatchRes.text();
        window.productSwatchCache[swatchResource] = swatchHtml;
        markSoldOutFromHTML(swatchHtml, swatch);
        preloadImagesFromHTML(swatchHtml);
      } catch (err) {
        console.warn(`Swatch preload failed for ${swatchResource}:`, err);
        (_a = swatch.parentElement) == null ? void 0 : _a.remove();
      } finally {
        delete window.productSwatchInFlight[swatchResource];
      }
    });
    const timebox = new Promise((resolve) => setTimeout(resolve, timeoutMs));
    return Promise.race([Promise.allSettled(tasks), timebox]).then(() => {
      const remaining = $card.querySelectorAll(".js-swap-product").length;
      applyMoreColorsIndicator($card);
      return { preloaded: swatches.length, remaining };
    });
  }
}
function hasPdpGateCookie() {
  return document.cookie.split("; ").some((c) => c.startsWith("pdp_gate="));
}
function isCustomerAuthenticated() {
  const isSitewideGated = document.body.classList.contains("private-gate-true");
  if (!isSitewideGated) return true;
  return hasPdpGateCookie();
}
export {
  applyMoreColorsIndicator as a,
  isCustomerAuthenticated as b,
  removeClass as c,
  addClass as d,
  initProductCardSwatchListeners as i,
  renderProductCardsFromHandles as r,
  utilityProductSwatch as u
};
